module.exports = __webpack_public_path__ + "img/suoxie.ac61da95.svg";